import {
  Routes,
  Route,
  RoutesProps,
  Navigate,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import { GoogleOAuthProvider } from "@react-oauth/google";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const Signup = React.lazy(() => import("../components/Login/Signup"));

  const Home = React.lazy(() => import("../pages/Home/Home"));
  const Notifications = React.lazy(() => import("../pages/Notitications/Notitications"));
  const List = React.lazy(() => import("../pages/Agenda/MyList/List"));
  const Events = React.lazy(() => import("../pages/Agenda/Events/Events"));
  const Task = React.lazy(() => import("../pages/Agenda/Task/Task"));
  const Reminders = React.lazy(() => import("../pages/Agenda/Reminders/Reminders"));
  const Gifts = React.lazy(() => import("../pages/Agenda/Gifts/Gifts"));
  const Completed = React.lazy(() => import("../pages/Agenda/Completed/Completed"));
  const Calendar = React.lazy(() => import("../pages/Calendar/Calendar"));
  const LovedOnes = React.lazy(() => import("../pages/Agenda/LovedOnes/Lovedones"));
  // Settings 
  const AccountSetting = React.lazy(() => import("../pages/Settings/AccountSeetings"));
  const SmartDeviceIntegration = React.lazy(() => import("../pages/Settings/SmartDeviceIntegration"));
  const NotificationsReminders = React.lazy(() => import("../pages/Settings/NotificationsReminders"));
  const ReminderSettings = React.lazy(() => import("../pages/Settings/ReminderSetting"));
  const CustomisationInterests = React.lazy(() => import("../pages/Settings/CustomisationInterests"));
  const PrivacySecurity = React.lazy(() => import("../pages/Settings/PrivacySecurity"));
  const Language = React.lazy(() => import("../pages/Settings/Language"));
  const Invite = React.lazy(() => import("../pages/Settings/Invite"));
  const HelpSupport = React.lazy(() => import("../pages/Settings/HelpSupport"));
  const ChangePassword = React.lazy(() => import("../pages/Settings/ChangePassword"));
  const Colors = React.lazy(() => import("../pages/Interest/CustomCategory"));
  const LovedOne = React.lazy(() => import("../pages/Interest/LovedOne"));
  const AddLovedOne = React.lazy(() => import("../pages/Interest/AddLovedOne"));

  const Profile = React.lazy(() => import("../pages/Profile/Profile"));
  const ForgotPassword = React.lazy(() => import("../components/Login/ForgotPassword"));
  const VerifyOtp = React.lazy(() => import("../components/Login/Otp"));
  const Verified = React.lazy(() => import("../components/Login/Verified"));
  const DeleteAccount = React.lazy(() => import("../components/Login/DeleteAccount"));


  return (
    <>
      <div id="main-wraper">
        <Routes>

          <Route path="/login" element={<Suspense fallback={<></>}>
            <GoogleOAuthProvider clientId="1016129428219-c9afm6lr2f3mhkj4v2mc76cm1md9jqtk.apps.googleusercontent.com">
              <Login />
            </GoogleOAuthProvider>

          </Suspense>} />

          <Route path="/signup" element={<Suspense fallback={<></>}>
            <GoogleOAuthProvider clientId="1016129428219-c9afm6lr2f3mhkj4v2mc76cm1md9jqtk.apps.googleusercontent.com">
              <Signup />
            </GoogleOAuthProvider>
          </Suspense>} />

          <Route
            path="/delete-account"
            element={
              <Suspense fallback={<></>}>
                <DeleteAccount />
              </Suspense>
            }
          />



          <Route path="/forgot-password" element={<Suspense fallback={<></>}> <ForgotPassword /> </Suspense>} />
          <Route path="/verify-otp" element={<Suspense fallback={<></>}> <VerifyOtp /> </Suspense>} />
          <Route path="/verified" element={<Suspense fallback={<></>}> <Verified /> </Suspense>} />
          {/* Redirect to login if no route matches */}
          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Suspense fallback={<></>}> <Home /> </Suspense>} />
            <Route path="/notifications" element={<Suspense fallback={<></>}> <Notifications /> </Suspense>} />
            {/* Agenda Pages  */}
            <Route path="/agenda/my-list" element={<Suspense fallback={<></>}> <List /> </Suspense>} />
            <Route path="/agenda/events" element={<Suspense fallback={<></>}> <Events /> </Suspense>} />
            <Route path="/agenda/tasks" element={<Suspense fallback={<></>}> <Task /> </Suspense>} />
            <Route path="/agenda/reminders" element={<Suspense fallback={<></>}> <Reminders /> </Suspense>} />
            <Route path="/agenda/explore-gift-ideas" element={<Suspense fallback={<></>}> <Gifts /> </Suspense>} />
            <Route path="/agenda/completed" element={<Suspense fallback={<></>}> <Completed /> </Suspense>} />
            <Route path="/agenda/loved_ones" element={<Suspense fallback={<></>}> <LovedOnes /> </Suspense>} />
            <Route path="/calendar" element={<Suspense fallback={<></>}> <Calendar /> </Suspense>} />

            {/* Settings */}
            {/* Account settings */}
            <Route path="/account-settings" element={<Suspense fallback={<></>}> <AccountSetting /> </Suspense>} />
            <Route path="/smart-device-integration" element={<Suspense fallback={<></>}> <SmartDeviceIntegration /> </Suspense>} />
            <Route path="/notifications-reminders" element={<Suspense fallback={<></>}> <NotificationsReminders /> </Suspense>} />
            <Route path="/reminder-settings" element={<Suspense fallback={<></>}> <ReminderSettings /> </Suspense>} />
            <Route path="/customisation-interests" element={<Suspense fallback={<></>}> <CustomisationInterests /> </Suspense>} />
            <Route path="/privacy-security" element={<Suspense fallback={<></>}> <PrivacySecurity /> </Suspense>} />
            <Route path="/language" element={<Suspense fallback={<></>}> <Language /> </Suspense>} />
            <Route path="/invite" element={<Suspense fallback={<></>}> <Invite /> </Suspense>} />
            <Route path="/help-support" element={<Suspense fallback={<></>}> <HelpSupport /> </Suspense>} />
            <Route path="/change-password" element={<Suspense fallback={<></>}> <ChangePassword /> </Suspense>} />
            <Route path="/colors" element={<Suspense fallback={<></>}> <Colors /> </Suspense>} />
            <Route path="/loved-ones" element={<Suspense fallback={<></>}> <LovedOne /> </Suspense>} />
            <Route path="/add-loved-one" element={<Suspense fallback={<></>}> <AddLovedOne /> </Suspense>} />
            <Route path="/add-loved-one/:id" element={<Suspense fallback={<></>}> <AddLovedOne /> </Suspense>} />

            {/* Profile Page */}

            <Route path="/profile" element={<Suspense fallback={<></>}> <Profile /> </Suspense>} />

          </Route>

        </Routes >
      </div >
    </>
  );
};

export default Navigation;
